import styled from 'styled-components';
import { theme } from 'consts/theme';

export const StyledHeaderRightWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
  gap: 16px;
  padding-right: 4px;
  color: ${theme.colors.white};
  height: 100%;
  font-size: 16px;
  font-weight: 500;
  text-align: end;
  text-overflow: ellipsis;
  overflow: hidden;
`;
